import angular from "angular";
import Vue from "vue";
import "ngVue";
import ImportWizard from "./ImportWizard.vue";
import ColumnMapper from "./ColumnMapper.vue";
import FileUploader from "./FileUploader.vue";
import ImportPreview from "./ImportPreview.vue";
import ImportResults from "./ImportResults.vue";
import MappingLoadModal from "./MappingLoadModal.vue";
import MappingSaveModal from "./MappingSaveModal.vue";

export {
  ImportWizard,
  ColumnMapper,
  FileUploader,
  ImportPreview,
  ImportResults,
  MappingLoadModal,
  MappingSaveModal,
};

export default angular
  .module("admin.directives.studentimport", [])
  .directive("dcImportWizard", [
    "createVueComponent",
    function (createVueComponent) {
      return createVueComponent(Vue.component("DcImportWizard", ImportWizard));
    },
  ]);
